import { render } from "./LandingHero.vue?vue&type=template&id=7afec8ca&scoped=true"
import script from "./LandingHero.vue?vue&type=script&lang=js"
export * from "./LandingHero.vue?vue&type=script&lang=js"

import "./LandingHero.vue?vue&type=style&index=0&id=7afec8ca&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afec8ca"]])

export default __exports__